// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { urlLinksResponseSchema } from '@/url-link/api/types';

/**
 * Requests a collection of URL links for a project from the remote API.
 *
 * @param key - The key of the project for which to request URL links.
 */
export async function getProjectURLLinks(key: string) {
  const path = `/v1/project/${key}/url-link`;
  const response = await api.get(path);

  return parseResponse(urlLinksResponseSchema, response.data, {
    schemaName: 'ProjectURLLinks',
    endpoint: path,
  });
}
